/**
 * Public Tour De Cure destinations used by CTAs and legal footer copy.
 * Donation URL confirmed on tourdecure.com.au; ABN from ABR / ACNC public records.
 */
export const TDC_HOME_URL = 'https://www.tourdecure.com.au';
export const TDC_DONATE_URL = 'https://www.tourdecure.com.au/donate';
export const TDC_CONTACT_EMAIL = 'info@nextonvera.com';
export const TDC_CONTACT_MAILTO = `mailto:${TDC_CONTACT_EMAIL}`;

/** Formatted ABN for display (spaces for readability). */
export const TDC_ABN_DISPLAY = '56 302 713 357';
/** Compact ABN digits for machine-readable contexts. */
export const TDC_ABN = '56302713357';

export const TDC_CHARITY_STATEMENT =
  'Tour De Cure is a registered Australian charity (ABN 56 302 713 357). Donations of $2 or more are tax deductible in Australia where eligible.';
